import type { HTMLAttributes } from "react";
import React from "react";
import styled from "styled-components";

import { theme } from "../../styles/theme";
import { UIConstants } from "../../styles/uiConstants";

/**
 * The white band at the top of a page, breaking out of the content column's padding so it spans
 * the full width. Carries the greeting on most screens, a page title on the others.
 */
export function PageHeaderBand(props: Readonly<HTMLAttributes<HTMLDivElement>>) {
  const { children, ...rest } = props;

  return (
    <Band {...rest}>
      <Inner>{children}</Inner>
    </Band>
  );
}

const Band = styled.div`
  align-self: stretch;
  margin: -80px -${UIConstants.CONTENT_HORIZONTAL_PADDING_NOT_DESKTOP}px 40px;
  padding: 80px ${UIConstants.CONTENT_HORIZONTAL_PADDING_NOT_DESKTOP}px 32px;
  background-color: #ffffff;

  @media (min-width: ${UIConstants.DESKTOP_SMALL_BREAKPOINT}px) {
    margin: -60px -${UIConstants.CONTENT_HORIZONTAL_PADDING_DESKTOP_SMALL}px 40px;
    padding: 60px ${UIConstants.CONTENT_HORIZONTAL_PADDING_DESKTOP_SMALL}px 32px;
  }

  @media (min-width: ${UIConstants.DESKTOP_LARGE_BREAKPOINT}px) {
    margin: -60px -${UIConstants.CONTENT_HORIZONTAL_PADDING_DESKTOP_LARGE}px 40px;
    padding: 60px ${UIConstants.CONTENT_HORIZONTAL_PADDING_DESKTOP_LARGE}px 32px;
  }
`;

const Inner = styled.div`
  display: flex;
  flex-direction: column;
`;

export const PageHeaderTitle = styled.span`
  ${theme.boldText};
  font-size: 32px;
  line-height: 42px;
  color: ${theme.colors.blue[800]};
`;

export const PageHeaderSubtitle = styled.span`
  ${theme.text};
  font-size: 20px;
  line-height: 30px;
  color: ${theme.colors.blue[800]};
`;
